const TYPE_NAMES = {
  top3: 'Топ',
  premium: 'Премиум',
  paid: 'Платное',
};

export const getServiceName = (services) => {
  return services
    .map((service) => TYPE_NAMES[service])
    .filter(Boolean)
    .join(' + ');
};
